exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectTag{position:relative;display:inline-block;padding:4px;border-radius:2px;padding-left:21px;padding-right:21px;margin-right:3px;margin-bottom:0;background:#ccc;line-height:1;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis;color:#555}legend .graphQuestion{margin-bottom:1px}", ""]);

// exports
